import React from "react";
import { Reveal, Eyebrow } from "../components/ui";

const contacts = [
  {
    title: "General Support",
    desc: "For app issues, login problems, or general questions:",
    email: "support@maxandsherry.mw",
  },
  {
    title: "Billing & Payments",
    desc: "For subscription inquiries, payment failures, or refund requests:",
    email: "billing@maxandsherry.mw",
  },
  {
    title: "Safety & Trust",
    desc: "To report abuse, fake profiles, or community guideline violations:",
    email: "safety@maxandsherry.mw",
  },
  {
    title: "Privacy & Data",
    desc: "For data export requests or privacy concerns:",
    email: "privacy@maxandsherry.mw",
  },
  {
    title: "Business & Partnerships",
    desc: "For corporate networking, venue partnerships, or press:",
    email: "hello@maxandsherry.mw",
  },
];

export default function Contact() {
  return (
    <main className="bg-white px-[5%] pt-[140px] pb-20 lg:pb-[100px]">
      <div className="max-w-[1100px] mx-auto">
        <Reveal>
          <Eyebrow>Support</Eyebrow>
        </Reveal>
        <Reveal delay={100}>
          <h1 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-4">
            Contact Us
          </h1>
        </Reveal>
        <Reveal delay={150}>
          <p className="text-[15px] text-muted mb-12 max-w-[560px] leading-relaxed">
            We are here to help. Whether you have a question about your
            subscription, need help with your account, or want to report a
            safety issue, please reach out to the right team below.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {contacts.map((c, i) => (
            <Reveal
              key={c.title}
              delay={200 + i * 50}
              className={`h-full ${i === contacts.length - 1 ? "md:col-span-2" : ""}`}
            >
              <div className="h-full flex flex-col p-6 lg:p-8 rounded-[20px] bg-blush border border-rose/10">
                <h2 className="text-lg font-bold tracking-tight mb-1">
                  {c.title}
                </h2>
                <p className="text-[14px] text-muted mb-5">{c.desc}</p>
                <a
                  href={`mailto:${c.email}`}
                  className="inline-flex items-center justify-center self-start mt-auto bg-white border border-black/10 text-black text-sm font-medium px-5 py-2.5 rounded-full hover:border-rose hover:text-rose transition-colors duration-200 no-underline"
                >
                  ✉️ {c.email}
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={500}>
          <p className="text-sm text-muted mt-12 text-center italic">
            We aim to respond to all inquiries within 24 to 48 hours. Our
            support hours are Monday to Friday, 8:00 AM to 5:00 PM (CAT).
          </p>
        </Reveal>
      </div>
    </main>
  );
}
